import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'core-js/stable'
//import './assets/main.css'
import firebase from 'firebase/compat/app'

import App from './App.vue'
import router from './router'
import store from './store'
import CoreuiVue from '@coreui/vue'
import { createPinia } from 'pinia'
import print from 'vue3-print-nb'
import eventBus from 'vue3-eventbus'
import jsPDF from 'jspdf'
import Loading from 'vue3-loading-overlay'
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/icons'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import zhTw from 'element-plus/dist/locale/zh-tw.mjs'
import moment from 'moment-timezone'


moment.tz.setDefault('Asia/Taipei')

let firebaseConfig = {}
console.log(process.env.NODE_ENV === 'production')
if (process.env.NODE_ENV === 'production') {
  firebaseConfig = {
    apiKey: 'AIzaSyBYEbk_0D2gIUsQ3xuYbiTBmT924lh30EU',
    authDomain: 'star-music-backend.firebaseapp.com',
    projectId: 'star-music-backend',
    storageBucket: 'star-music-backend.appspot.com',
    messagingSenderId: '960398920829',
    appId: '1:960398920829:web:c164ef81a86ddf2c97b514',
    measurementId: 'G-75W2KDFBN2',
  }
} else {
  firebaseConfig = {
    apiKey: 'AIzaSyAYsPuUuESKn5Je5QmeX_C7Nh0QzhUn2NM',
    authDomain: 'star-music-backend-dev.firebaseapp.com',
    projectId: 'star-music-backend-dev',
    storageBucket: 'star-music-backend-dev.appspot.com',
    messagingSenderId: '966158644414',
    appId: '1:966158644414:web:5871f22beec7d65cbb1aef',
    measurementId: 'G-YCY0WQYJDH',
  }
}

firebase.initializeApp(firebaseConfig)
const pinia = createPinia()

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.config.globalProperties.navigator = window.navigator
app.use(store)
app.use(router)
app.use(CoreuiVue)
app.use(print)
app.use(eventBus)
app.use(jsPDF)
app.use(VueAxios, axios)
app.use(ElementPlus, {
  locale: zhTw,
})
app.use(pinia)

app.provide('icons', icons)

app.component('CIcon', CIcon)
app.component('Loading', Loading)

app.mount('#app')

app.$http = axios

const debounce = (fn, delay) => {
  let timer = null
  return function () {
    let context = this
    let args = arguments
    clearTimeout(timer)
    timer = setTimeout(function () {
      fn.apply(context, args)
    }, delay)
  }
}

const _ResizeObserver = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16)
    super(callback)
  }
}
